import api from './api';

const paymentporterService = {
    list: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.partner_id) params.append('partner_id', filters.partner_id);
        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
        if (filters.active !== undefined) params.append('active', filters.active);
        if (filters.search) params.append('search', filters.search);
        return api.get(`/paymentporter${params.toString() ? '?' + params.toString() : ''}`);
    },

    getSetupData: async (hotelId, accountId) => {
        const params = new URLSearchParams({ setup: '1' });
        if (hotelId)   params.append('hotel_id',   hotelId);
        if (accountId) params.append('account_id', accountId);
        return api.get(`/paymentporter?${params.toString()}`);
    },

    getById: async (id) => {
        return api.get(`/paymentporter/${id}`);
    },

    create: async (data) => {
        return api.post('/paymentporter', data);
    },

    update: async (id, data) => {
        return api.put(`/paymentporter/${id}`, data);
    },

    remove: async (id) => {
        return api.delete(`/paymentporter/${id}`);
    },

    // Verification + defaults are served by the shared ui-v2-notifications lambda (/notifications/*).
    getNotificationDefaults: async (hotelId, accountId) => {
        const params = new URLSearchParams();
        if (hotelId)   params.append('hotel_id',   hotelId);
        if (accountId) params.append('account_id', accountId);
        return api.get(`/notifications/defaults?${params.toString()}`);
    },

    // Rules — a porter contains many rules; each rule owns its own criteria/actions/window
    listRules:    (ppId)             => api.get(`/paymentporter/${ppId}/rules`),
    getRule:      (ppId, ruleId)     => api.get(`/paymentporter/${ppId}/rules/${ruleId}`),
    createRule:   (ppId, data)        => api.post(`/paymentporter/${ppId}/rules`, data),
    updateRule:   (ppId, ruleId, data)=> api.put(`/paymentporter/${ppId}/rules/${ruleId}`, data),
    deleteRule:   (ppId, ruleId)     => api.delete(`/paymentporter/${ppId}/rules/${ruleId}`),
    // Bulk Excel upload. The workbook is parsed and validated in the browser (utils/ppRuleWorkbook) and
    // sent as JSON; the server re-validates and forces every created rule inactive.
    importRules:  (ppId, data)        => api.post(`/paymentporter/${ppId}/rules-import`, data),
    // The complete evaluation order, written in one call. Sequence decides which rule claims a
    // reservation (first match wins), so a half-applied reorder would change routing — the server
    // takes the whole list and renumbers 1..N in a transaction.
    reorderRules: (ppId, ruleIds)     => api.put(`/paymentporter/${ppId}/rules-reorder`, { ruleIds }),
    // Superadmin — send the daily summary now instead of waiting for the 23:55 UTC job.
    notifyNow:    (ppId)              => api.post(`/paymentporter/${ppId}/notify-now`, {}),

    purgeRuns:                (ppId)             => api.delete(`/paymentporter/${ppId}/runs`),
    listNotificationEmails:   (ppId)             => api.get(`/paymentporter/${ppId}/notification-emails`),
    addNotificationEmail:     (ppId, data)        => api.post(`/paymentporter/${ppId}/notification-emails`, data),
    removeNotificationEmail:  (ppId, emailId)     => api.delete(`/paymentporter/${ppId}/notification-emails/${emailId}`),
    sendVerificationCode:     (email)             => api.post('/notifications/email/send-code', { email }),
    verifyCode:               (email, code)       => api.post('/notifications/email/verify-code', { email, code }),
    sendTeamsWebhookCode:     (webhookUrl)        => api.post('/notifications/teams-webhook/send-code',   { webhook_url: webhookUrl }),
    verifyTeamsWebhookCode:   (webhookUrl, code)  => api.post('/notifications/teams-webhook/verify-code', { webhook_url: webhookUrl, code }),
    createInvoice:            (data)                    => api.post('/paymentporter/invoice', data),
};

export default paymentporterService;
